import { Dispatch, PayloadAction } from '@reduxjs/toolkit';

import configLib from '../../configLib';
import { DetailedAccount } from '../models/crm/types';
import { isGatewayMDFullyEnabled } from '../store/selectors';
import { isDemoAccountReference, isUsableAccountStatus } from '../util/account-helpers';
import { isPlanPurchaseCallbackInProgress } from '../util/url-helpers';

import { GatewayWebSocketService } from './web-socket/GatewayWebSocket.service';
import GatewayRestService from './GatewayRest.service';
import services from './index';
import { NewsService } from './News.service';
import {
  IAMSService,
  IAuthService,
  ICloseoutService,
  ICommonAuthService,
  ICRMService,
  IFileService,
  IFundamentalService,
  IMarketDataService,
  INewsService,
  IPaymentService,
  IReportingFileService,
  IReportingService,
  ITradingService,
} from './types';

class GlobalService {
  dispatch: (action: PayloadAction<any>) => void;

  public static gatewayRest: GatewayRestService;

  public static globalService: GlobalService;

  public static marketDataService: IMarketDataService;

  public static newsService: INewsService;

  public static fileService: IFileService;

  public static authService: IAuthService & ICommonAuthService;

  public static crmService: ICRMService;

  public static fundamentalService: IFundamentalService;

  public static reportingService: IReportingService;

  public static reportingFileService: IReportingFileService;

  public static tradeService: ITradingService;

  public static paymentService: IPaymentService;

  public static amsService: IAMSService;

  public static closeoutService: ICloseoutService;

  public static createServicesWithoutToken() {
    GlobalService.authService = services.createAuthService();
    GlobalService.crmService = services.createCRMService();
  }

  // TODO: ART-3959 this logic will be refactored
  public static createServices(dispatch: Dispatch) {
    GlobalService.globalService = new GlobalService(dispatch);
    GlobalService.tradeService = services.createTradingService(dispatch);
    // REST
    GlobalService.gatewayRest = services.createGatewayRestService();
    GlobalService.crmService = services.createCRMService();
    GlobalService.newsService = NewsService.getInstance();
    GlobalService.fileService = services.createFileService();
    GlobalService.fundamentalService = services.createFundamentalService();
    GlobalService.reportingService = services.createReportingService();
    GlobalService.reportingFileService = services.createReportingFileService();
    GlobalService.paymentService = services.createPaymentService();
    GlobalService.amsService = services.createAmsService();
    GlobalService.closeoutService = services.createCloseoutService();
    // to be deprecated
    if (!isGatewayMDFullyEnabled()) {
      GlobalService.marketDataService = services.createMarketDataService(dispatch);
    }
  }

  /**
   * Connects Web Socket services - Gateway and TAPI
   * (Direct WS connection to MDS is not used any more but is still not removed from code and can be easily used for debugging for example)
   */
  public static connect(_isReconnect = false) {
    const gatewayWebSocketService = GatewayWebSocketService.getInstance();
    const isGatewayConnected = !!gatewayWebSocketService?.isConnected();
    if (!isGatewayConnected) {
      gatewayWebSocketService.connect();
    }

    if (!isGatewayMDFullyEnabled()) {
      GlobalService.marketDataService.connect();
    }
  }

  /**
   * Disonnects Web Socket services - Gateway and TAPI
   * (Direct WS connection to MDS is not used any more but is still not removed from code and can be easily used for debugging for example)
   */
  public static disconnect() {
    const gatewayWebSocketService = GatewayWebSocketService.getInstance();
    const isGatewayConnected = !!gatewayWebSocketService?.isConnected();
    const isTradeServiceConnected = GlobalService.tradeService?.isConnected();
    if (isTradeServiceConnected) {
      GlobalService.tradeService?.disconnect();
    }
    if (isGatewayConnected) {
      gatewayWebSocketService?.disconnect();
    }
    if (!isGatewayMDFullyEnabled()) {
      GlobalService.marketDataService?.disconnect();
    }
  }

  constructor(dispatch: Dispatch) {
    this.dispatch = dispatch;
  }

}


export default GlobalService;
